import './styles.css';
import { Grid, Tooltip, IconButton, Menu, MenuItem, Typography } from '@material-ui/core';
import { HomeOutlined, MenuBookOutlined, MusicNoteOutlined, LibraryMusic, CoPresent, SpeedOutlined, SettingsVoice } from '@mui/icons-material';
import { useState, Fragment} from 'react';
import { useIsMobileScreen, useIsTinyMobileScreen} from './hooks/screenSizeHooks';
import { useNavigate, useLocation } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';


export const learnList = [
  {name: 'Learn: Introduction', url: '/learn/introduction'},
  {name: 'Learn: C Major - all natural', url: '/learn/c_major'},
  {name: 'Learn: G Major - 1 sharp', url: '/learn/g_major'},
  {name: 'Learn: F Major - 1 flat', url: '/learn/f_major'},
  {name: 'Learn: D Major - 2 sharps', url: '/learn/d_major'},
  {name: 'Learn: B♭ Major - 2 flats', url: '/learn/b_flat_major'},
  {name: 'Learn: A Major - 3 sharps', url: '/learn/a_major'},
  {name: 'Learn: E♭ Major - 3 flats', url: '/learn/e_flat_major'},
  {name: 'Learn: E Major - 4 sharps', url: '/learn/e_major'},
  {name: 'Learn: A♭ Major - 4 flats', url: '/learn/a_flat_major'},
  {name: 'Learn: 3rd position - Introduction', url: '/learn/3rd_introduction'},
  {name: 'Learn: 3rd position - C, D, F Major', url: '/learn/3rd_introduction_patterns'},
];

export const practiseList = [
  {name: 'Practice: Intro & How to use it', url: '/practice/introduction_how_to_use'},
  {name: 'Practice: C Major - all natural', url: '/practice/c_major'},
  {name: 'Practice: G Major - 1 sharp', url: '/practice/g_major'},
  {name: 'Practice: F Major - 1 flat', url: '/practice/f_major'},
  {name: 'Practice: D Major - 2 sharps', url: '/practice/d_major'},
  {name: 'Practice: B♭ Major - 2 flats', url: '/practice/b_flat_major'},
  {name: 'Practice: A Major - 3 sharps', url: '/practice/a_major'},
  {name: 'Practice: E♭ Major - 3 flats', url: '/practice/e_flat_major'},
  {name: 'Practice: E Major - 4 sharps', url: '/practice/e_major'},
  {name: 'Practice: A♭ Major - 4 flats', url: '/practice/a_flat_major'},
  {name: 'Practice: 3rd position - C Major', url: '/practice/3rd_c_major'},
  {name: 'Practice: 3rd position - G Major', url: '/practice/3rd_g_major'},
  {name: 'Practice: 3rd position - F Major', url: '/practice/3rd_f_major'},
  {name: 'Practice: 3rd position - D Major', url: '/practice/3rd_d_major'},
  {name: 'Practice: 1st & 3rd positions Mix', url: '/practice/mix_1st_and_3rd_pos'},
];

export const flashcardsList = [
  {name: 'For Violin', url: '/flashcards/for_violin'},
  {name: 'For Piano', url: '/flashcards/for_piano'}
];

const pageIconButtons = [
  {pageTitle: 'Home', buttonIcon: <HomeOutlined style={{color: ' #ffffff'}} fontSize='large'/>, pageControl: 'Home'},
  {pageTitle: 'Flashcards', buttonIcon: <LibraryMusic style={{color: ' #ffffff'}} fontSize='large'/>, pageControl: 'Flashcards'},
  {pageTitle: 'SightPlay Challenge', buttonIcon: <SettingsVoice style={{color: ' #ffffff'}} fontSize='large'/>, pageControl: 'SightPlay'},
  {pageTitle: 'Learn', buttonIcon: <MenuBookOutlined style={{color: ' #ffffff'}} fontSize='large'/>, pageControl: 'Learn'},
  {pageTitle: 'Practice & Navigate', buttonIcon: <MusicNoteOutlined style={{color: ' #ffffff'}} fontSize='large' />, pageControl: 'Practice'},
  {pageTitle: 'Violin Tuner', buttonIcon: <SpeedOutlined style={{color: ' #ffffff'}} fontSize='large'/>, pageControl: 'Tuner'},
  {pageTitle: 'About & Contact', buttonIcon: <CoPresent style={{color: ' #ffffff'}} fontSize='large' />, pageControl: 'About'},
]

function AppHeaderMenu() {
  const isMobileScreen = useIsMobileScreen();
  const isTinyMobileScreen = useIsTinyMobileScreen();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMenuButton, setSelectedMenuButton] = useState('')
  const [menuList, setMenuList] = useState([])
  const open = Boolean(anchorEl);
  let navigate = useNavigate();
  const location = useLocation();
  const iconsFitInline = useMediaQuery('(min-width:686px)');  // This is for the icons fitting. Subject to changes depending on how many

  const handleRedirect = (redirectURL) => navigate(redirectURL)

  const handleClick = (event, pageControl) => {
    if(pageControl === 'Learn' || pageControl === 'Practice' || pageControl === 'Flashcards') {
      const findMenuList = pageControl === 'Learn' ? learnList :  pageControl === 'Practice' ? practiseList : flashcardsList;
      setMenuList(findMenuList)
      setAnchorEl(event.currentTarget);
      setSelectedMenuButton(pageControl)
    } else {
      pageControl === 'About' ? handleRedirect('/about') : pageControl === 'Tuner' ? handleRedirect('/tune_violin') : pageControl === 'SightPlay' ? handleRedirect('/pitch_tests') :handleRedirect('')
      setMenuList([])
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
    setSelectedMenuButton('')
  };

  return(
    <div className="appHeader" > 
      <Grid container direction='row' justifyContent='space-between' alignItems='center'>
        <Grid item style={!iconsFitInline ? {width: '100%', display: 'flex', justifyContent: 'center', cursor: 'pointer'} : {cursor: 'pointer'}} onClick={() => handleRedirect('')}>
          {!iconsFitInline  ?
            <Typography variant='h5' className='appTitle' style={{lineHeight: '22px'}}>Violin
              <img 
                src="https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExYmx5ZzN6dnI4dDh5bGp0Z3ppMThiOWloY2p0aG11NnFsOTV0NmJtaiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/SYQfgTam3ZeagUqfgk/giphy.gif" 
                style={{maxHeight: '40px', verticalAlign: "sub"}}
                alt="ViolinScope Gif"
              />
              Scope</Typography>
          :
            <Grid container direction="row" justifyContent='center'>
              <img 
                src="https://i.giphy.com/media/v1.Y2lkPTc5MGI3NjExYmx5ZzN6dnI4dDh5bGp0Z3ppMThiOWloY2p0aG11NnFsOTV0NmJtaiZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9cw/SYQfgTam3ZeagUqfgk/giphy.gif" 
                style={{maxHeight: '70px'}}
                alt="ViolinScope Gif"
              />
              <Typography variant='h4' className='appTitle'>ViolinScope</Typography>
            </Grid>
          }
        </Grid>
        <Grid item style={!iconsFitInline ? {width: '100%', display: 'flex', justifyContent: 'center'} : {}}>
          {pageIconButtons.map((item, i) => (
            <span key={i}>
              <Tooltip 
                title={<Fragment><Typography color="inherit">{item.pageTitle} </Typography></Fragment>} 
                key={`menu-tooltip-${i}`} 
                arrow
              >
                <IconButton
                  // tabIndex={i}
                  key={`menu-button-${i}`}
                  style={{backgroundColor: selectedMenuButton === item.pageControl ? ' #812092': '', margin: isMobileScreen? 3 : 5, maxWidth: isTinyMobileScreen ? '33px' : ''}}
                  onClick={ e => handleClick(e, item.pageControl)}
                  size={isMobileScreen ? "small": "medium"}
                  sx={{ ml: 2 }}
                  aria-controls={open ? item.pageControl : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? 'true' : undefined}
                >
                  {item.buttonIcon}
                </IconButton>
              </Tooltip>
              <Menu
                key={`menu-list-${i}`}
                getContentAnchorEl={null}
                anchorEl={anchorEl}
                id={item.pageControl}
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 4,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&::before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                {menuList.map((course, index) => (
                  <MenuItem 
                    onClick={() => handleRedirect(course.url)} 
                    key={`menu-list-item-${index}`} 
                    disabled={course.url === location.pathname}
                    style={{color: course.name.includes('3rd position') ?  ' #0c668d' : ' #6f1c7d'}}
                  >
                    {course.name}
                  </MenuItem>
                ))}
              </Menu>
            </span>              
          ))}
        </Grid>
      </Grid>
    </div>
  )
}

export default AppHeaderMenu;